import MultyInput from './MultyInput';

export default MultyInput;
